import {BreadCrumbs} from "../../../components/open/pages";

export const AdminWebsiteScreen = () => {
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'وبسایت', url: '/admins/website'},
            ]}/>
        </>
    );
};